import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@services/authentication.service';
import { CustomValidator } from '@validators/custom-validator';
import { Router } from '@angular/router';

@Component({
  selector: 'csl-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  public frmSignup: UntypedFormGroup;
  error: any;
  submitted = false;
  showSpinner = false;

  constructor(private fb: UntypedFormBuilder, private authService:AuthenticationService, public router: Router) {
    this.frmSignup = this.createSignupForm();
    this.error = false;
    this.submitted = false;
  }

  createSignupForm(): UntypedFormGroup {
    return this.fb.group(
      {
        userName: [
          null,
          Validators.compose([Validators.pattern('^[a-zA-Z0-9 \'\-]+$'), Validators.required])
        ],
        email: [
          null,
          Validators.compose([Validators.email, Validators.required])
        ],
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidator.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidator.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidator.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidator.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidator.passwordMatchValidator
      }
    );
  }

  submit() {
    // do signup or something
    this.error = false;
    this.submitted = false;
    return this.authService.
              registerUser(this.frmSignup.value.userName,
                          this.frmSignup.value.email,
                          this.frmSignup.value.password).subscribe(
                                  _val =>  {this.frmSignup.reset();
                                            this.submitted = true;
                                            this.toggleSpinner();
                                            this.router.navigate(['login']);},
                            error => {this.error = error;
                              this.toggleSpinner()
                              this.frmSignup.reset();
                            }
                          )
  }

  toggleSpinner() {
    this.showSpinner = !this.showSpinner;

}

  ngOnInit(): void {
    // Intentionally left empty
  }

}
